var path = 'app/scripts/modules/ecs/pipeline/stages/findImageFromTags/findImageFromTagsStage.html';
var html = "<div ng-controller=\"ecsFindImageFromTagsStageCtrl as findImageFromTagsCtrl\" class=\"form-horizontal\">\n  <stage-config-field label=\"Full Docker Image path (label or SHA-256)\">\n    <input type=\"text\" class=\"form-control input-sm\"\n           ng-model=\"stage.imageLabelOrSha\"/>\n  </stage-config-field>\n</div>\n\n<div>\n  <h5>\n    Example value: <i>769716316905.dkr.ecr.us-west-2.amazonaws.com/continuous-delivery:latest</i>\n  </h5>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/pipeline/stages/findImageFromTags/findImageFromTagsStage.html
// module id = 1609
// module chunks = 0